import { colors } from "themes/variables"
import styles from "./AddAvatar.module.css"
import { Icon } from "ui/Icon"
import { CustomInput } from "ui/Input"
import { Avatar } from "antd"
import PropTypes from "prop-types"
import { useIsWideImage } from "hooks/useIsWideImage"

export const AddAvatar = ({ avatar, handleImageChange, isContain = false }) => {
  let avatarSrc = avatar
  if (typeof avatar === "string") {
    avatarSrc = avatar.includes("localhost")
      ? avatar.replace("https://", "http://")
      : avatar
  }

  const isWide = useIsWideImage(isContain ? avatarSrc : null)

  return (
    <div className={`${styles.avatarWrapper} ${isContain && isWide ? styles.isContain : ""}`}>
      <Avatar
        src={avatarSrc}
        style={{
          border: `1.5px solid ${colors.lines}`,
          flexShrink: 0,
          background: colors.surface1,
          borderRadius: "50%"
        }}
        size={100}
        icon={<Icon width={16} height={16} type="feather" name="User" color={colors.textTertiary} />}
      />
      <div className={styles.avatarAction}>
        <label className={styles.avatarLabel} htmlFor="avatarPhoto">
          <div className={styles.avatarActionIconWrapper}>
            <Icon width={16} height={16} type="feather" name={avatar ? "Edit2" : "Plus"} color={colors.textSecondary} />
          </div>
        </label>
        <CustomInput
          className={styles.avatarPhotoInput}
          id="avatarPhoto"
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleImageChange}
        />
      </div>
    </div>
  )
}

AddAvatar.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleImageChange: PropTypes.func.isRequired,
  isContain: PropTypes.bool
}
